import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from 'react-i18next';
import { i18nextInstance } from './i18n';
import App from "./containers/App";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";

ReactDOM.render(
    <I18nextProvider i18n={i18nextInstance}>
        <App />
    </I18nextProvider>,
    document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js